﻿!function () {
  // 接口列表
  window.Apipath = {
    getBgzx: function(t){
      switch (t) {
        case "1": return "/static/jsonData/bgzx-jt.json";
        case "2": return "/static/jsonData/bgzx-hy.json";
        case "3": return "/static/jsonData/bgzx-ld.json";
        case "4": return "/static/jsonData/bgzx-cp.json";
        case "5": return "/static/jsonData/bgzx-gy.json";
        case "6": return "/static/jsonData/bgzx-fw.json";
        case "7": return "/static/jsonData/bgzx-jd.json";
        case "8": return "/static/jsonData/bgzx-mm.json";
        case "9": return "/static/jsonData/bgzx-gscs.json";
        default: return "/static/jsonData/bgzx.json";
      }
    },
    getBgAnswer: function(t){
      switch (t) {
        case "1": return "/static/jsonData/bgzxAnswer-jt.json";
        case "2": return "/static/jsonData/bgzxAnswer-hy.json";
        case "3": return "/static/jsonData/bgzxAnswer-ld.json";
        case "4": return "/static/jsonData/bgzxAnswer-cp.json";
        case "5": return "/static/jsonData/bgzxAnswer-gy.json";
        case "6": return "/static/jsonData/bgzxAnswer-fw.json";
        case "7": return "/static/jsonData/bgzxAnswer-jd.json";
        case "8": return "/static/jsonData/bgzxAnswer-mm.json";
        case "9": return "/static/jsonData/bgzxAnswer-gscs.json";
      }
    },
    createDoc: function(){
      return '/api/writ/v2/getUid';
    },
    getBg: function(){
      return "/static/bgImage.json";
    },
    getCodeInfo: function(){
      return '/api/writ/v2/getCodeInfo';
    },
    sendNewMail: function(){
      return '/api/writ/v2/sendMail';
    },
    returnHtml:function () {
      return '/api/sceneconsultcase/v2/findByFilename';
    }
  }
}();



//////////////////
// WEBPACK FOOTER
// ./src/service/api.js
// module id = 354
// module chunks = 1